import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import SegundoFactorTab from './sistema/SegundoFactorTab';

interface AgregarSegundoFactorDialogProps {
  open: boolean;
  onClose: () => void;
}

const AgregarSegundoFactorDialog: React.FC<AgregarSegundoFactorDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>Agregar segundo factor</DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        {open && <SegundoFactorTab hideTitle onEnabled={onClose} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgregarSegundoFactorDialog;
